import "../components/plasmic/fb_rerum/plasmic.css"; // plasmic-import: frLTK57AGre4oWC8c14hh8/projectcss
import "@/styles/globals.css";
import "survey-core/survey-core.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {LGRuntimeProvider, useRuntimeConfig} from "@lg-plus/landing-components";
import {GoogleTag} from "@lg-plus/landing-components/GoogleTag";
import {MetaPixel} from "@lg-plus/landing-components/MetaPixel";
import {PlasmicRootProvider} from "@plasmicapp/react-web";
import type {AppProps} from "next/app";
import Head from "next/head";
import Link from "next/link";
export default function MyApp({Component, pageProps}: AppProps) {
    const config = useRuntimeConfig(pageProps);

    return (
        <PlasmicRootProvider Head={Head} Link={Link}>
            <Head>
                <link rel="icon" type="image/png" href="/favicon.png" />
            </Head>
            <GoogleTag gtmId={config.gtmId} gtmCustomParams={config.gtmCustomParams} />
            <MetaPixel pixelId={config.metaPixelId} />
            <LGRuntimeProvider
                config={config}
                initialCommand={pageProps.initialCommand}
                initialFormData={pageProps.initialFormData}
                flashMessage={pageProps.flashMessage}
            >
                <Component {...pageProps} />
            </LGRuntimeProvider>
        </PlasmicRootProvider>
    );
}
